<template>
    <UApp :locale="uiLocale">
        <UTheme :props="uiDefaults">
            <!-- The hotel has not bought this module, so there is no round to draw and no
                 screen underneath that could answer. It replaces the app rather than
                 sitting inside a layout: the navigation strip would offer tabs that are
                 all refused.

                 The kiosk is exempt, and it has to be. The flag is cleared only by
                 signing out and in (libs/license.ts), which is the one thing a person on
                 a telephone can do about it — and a corridor tablet holds a DEVICE key
                 and no session, so it never signs in or out and nothing on it could ever
                 clear the flag. One refused press would replace that wall's clock with a
                 notice for good, surviving the licence coming back, until somebody
                 thought to reload a tablet that nobody ever reloads. Its own refusals
                 belong on its own screen, where they are already drawn and where the
                 next press retries them. -->
            <ModuleNotice v-if="moduleUnlicensed && !isDevice" />

            <component :is="layout" v-else>
                <router-view />
            </component>
        </UTheme>
    </UApp>
</template>

<script lang="ts" setup>
    import * as locales from '@nuxt/ui/locale'
    import { computed, onMounted } from 'vue'
    import { useI18n } from 'vue-i18n'
    import { useRoute } from 'vue-router'

    import ModuleNotice from '@/components/ModuleNotice.vue'
    import Blank   from '@/layouts/Blank.vue'
    import Default from '@/layouts/Default.vue'
    import Kiosk   from '@/layouts/Kiosk.vue'
    import { moduleUnlicensed } from '@/libs/license'
    import { uiDefaults } from '@/libs/uiDefaults'
    import { usePointerGuard } from '@/libs/pointerGuard'

    const route = useRoute()
    const { locale } = useI18n()

    // Keeps Nuxt UI's built-in component texts in sync with the vue-i18n locale.
    const uiLocale = computed(() => (locales as Record<string, typeof locales.en>)[locale.value] ?? locales.en)

    const layouts = { Default, Blank, Kiosk }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])

    /**
     * Whether this screen is a DEVICE rather than a signed-in person — which today means
     * the corridor kiosk, and is read off the layout because the layout is exactly what
     * that distinction already produces. See the notice above for why it matters.
     */
    const isDevice = computed((): boolean => layout.value === Kiosk)

    // Watches for the click lock a closed dialog can leave on the page. The portal is
    // used on a telephone, where a page that stops responding is even harder to explain
    // than at a desk — and a housekeeper cannot be asked to reload it.
    onMounted(usePointerGuard)
</script>
